import { Checkbox, DatePicker, Form, Input, Radio, Select, Space } from 'antd';
import React from 'react';

import { EDUTAINMENT_PLACE_OPTIONS } from '../../../constants';
import { FixedSchedule } from '../../../FixedSchedule';
import { validateTimeRange } from '../../../helpers';
import { NonFixedSchedule } from '../../../NonFixedSchedule';
import type { EditEdutainmentFormValues } from '../../types';
import { SCHEDULE_TYPE_OPTIONS } from './constants';
import styles from './index.module.scss';

const { Item, useFormInstance, useWatch } = Form;

export const ScheduleSection = () => {
  const isRegular = useWatch<
    EditEdutainmentFormValues['isRegular'] | undefined
  >('isRegular');
  const scheduleType = useWatch<
    EditEdutainmentFormValues['scheduleType'] | undefined
  >('scheduleType');
  const irregular = useWatch<
    EditEdutainmentFormValues['irregular'] | undefined
  >('irregular');

  const form = useFormInstance();

  // TODO: 非常態性課程的地點，看是要用哪些資料組成
  const irregularPlaceOptions = [
    ...EDUTAINMENT_PLACE_OPTIONS,
    { label: '其他', value: '其他' },
  ];

  const isOtherPlace = irregular?.place === '其他';

  return (
    <Space direction="vertical" className={styles.section}>
      <h4>育樂時刻表</h4>
      <Space
        direction="vertical"
        size="middle"
        className={styles.mainContentContainer}
      >
        <div className={styles.regularityAndDateRangeContainer}>
          <div className={styles.item}>
            <Item
              label="是否為常態性課程"
              name="isRegular"
              rules={[{ required: true, message: '請選擇其中一項' }]}
            >
              <Radio.Group
                onChange={() => form.resetFields(['irregular', 'scheduleType'])}
              >
                <Radio value={true}>常態課程</Radio>
                <Radio value={false}>非常態課程（單堂販售）</Radio>
              </Radio.Group>
            </Item>
          </div>

          <div className={styles.item}>
            <Space size="middle">
              <Item
                label="育樂起始時間"
                name={['program', 'startTime']}
                className={styles['flex-1']}
                rules={[
                  {
                    required: true,
                    validator: (_, startTime) =>
                      validateTimeRange({
                        isStartTime: true,
                        startTime,
                        endTime: form.getFieldValue(['program', 'endTime']),
                      }),
                  },
                ]}
              >
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  placeholder="請選擇起始時間"
                  className={styles['w-full']}
                />
              </Item>
              <Item
                label="育樂截止時間"
                name={['program', 'endTime']}
                className={styles['flex-1']}
                rules={[
                  {
                    required: true,
                    validator: (_, endTime) =>
                      validateTimeRange({
                        isStartTime: false,
                        startTime: form.getFieldValue(['program', 'startTime']),
                        endTime,
                      }),
                  },
                ]}
              >
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  placeholder="請選擇截止時間"
                  className={styles['w-full']}
                />
              </Item>
            </Space>
          </div>
        </div>

        {isRegular && (
          <Item
            label="課程時間設定（需至少擇一，但可複選）"
            name="scheduleType"
            rules={[{ required: true, message: '需至少選擇一項' }]}
          >
            <Checkbox.Group options={SCHEDULE_TYPE_OPTIONS} />
          </Item>
        )}
        {scheduleType?.includes('fixedTime') && <FixedSchedule />}
        {scheduleType?.includes('nonFixedTime') && <NonFixedSchedule />}

        {!isRegular && (
          <Space direction="vertical">
            <Item
              label="育樂地點"
              name={['irregular', 'place']}
              rules={[{ required: true, message: '請選擇地點' }]}
            >
              <Select
                options={irregularPlaceOptions}
                placeholder="請選擇地點"
                className={styles.placeSelector}
                onChange={() =>
                  form.setFieldValue(['irregular', 'address'], null)
                }
              />
            </Item>
            <Space align="baseline">
              <p>其他：</p>
              <Item
                name={['irregular', 'address']}
                rules={[
                  {
                    required: isOtherPlace,
                    message: '請輸入地址',
                  },
                ]}
              >
                <Input
                  placeholder="請輸入地址"
                  className={styles.addressInput}
                  disabled={!isOtherPlace}
                />
              </Item>
            </Space>
          </Space>
        )}
      </Space>
    </Space>
  );
};
